define('home/views/RelatedDiscussionView',[
    'backbone-marionette',

    'home/templates/relatedDiscussion',
    'home/mixins/withTruncate',
], function (
    Marionette,

    relatedDiscussionTemplate,
    withTruncate
) {
    'use strict';

    /**
     * A view that shows a recommended discussion item.
     * Template assumes an Activity object with a `thread` path.
     */
    var RelatedDiscussionView = Marionette.ItemView.extend({
        template: relatedDiscussionTemplate,
        className: 'module-recent__item',

        initialize: function (options) {
            this.hideImage = options && options.hideImage;
        },

        templateHelpers: function () {
            var thread = this.model.thread;

            return {
                image: !this.hideImage && this.model.thread.getImage(),
                discussionRoute: thread.getDiscussionRoute(),
            };
        },
    });

    withTruncate.call(RelatedDiscussionView.prototype);

    return RelatedDiscussionView;
});

